module.exports = __webpack_public_path__ + "img/placeholder-profile_3_7.8cd0b4e0.png";